import queryString from 'query-string';
import { path } from 'ramda';

import { featureFlagKeys } from 'modules/common/drawers/featureFlagDrawer/const/featureFlagKeys';

import { getIsLoggedIn, getFeatureFlagValue } from 'store/session/selectors';

const getScope = (state) => state.app;

export const isLoaded = (state) => state.app.loaded;

export const getModel = (state) => getScope(state).model;

export const getData = (state) => getModel(state);

export const getRouter = (state) => state.router;

export const getRouterSearchParams = (state) => {
  const search = path(['location', 'search'], getRouter(state));
  return search ? queryString.parse(search) : {};
};

export const getIsLoaded = (state) => getScope(state).isLoaded;

export const getIsFetching = (state) => getScope(state).isFetching;

export const getDidUserSessionExpire = (state) =>
  getScope(state).userSessionExpired;

export const getNextLocation = (state) => getScope(state).nextLocation;

export const getPrevLocation = (state) => getScope(state).prevLocation;

export const getLocation = (state) => getScope(state).location;

export const getError = (state) => getScope(state).error;

export const getHomePage = (state, isLoggedIn = null) => {
  if (isLoggedIn === null || isLoggedIn === true) {
    if (
      getFeatureFlagValue(state, featureFlagKeys.isQuotingToolAvailable) ===
      false
    ) {
      return '/parts?page=1&tab=our_parts';
    }
    return '/home';
  } else {
    // route non-logged in users to login page
    return '/login';
  }
};

export const getHomeOrLoginPage = (state) =>
  getIsLoggedIn(state) ? getHomePage(state) : '/login';
